<template>
  <table>
    <thead v-if="$slots.headers">
      <slot name="headers" />
    </thead>
    <slot name="rows" />
  </table>
</template>
